const services = [
  {
    icon: 'ri-sofa-line',
    title: 'Koltuk Yıkama',
    description: 'Derin temizleme yöntemleriyle koltuk ve kanepenizi fabrika çıkışı tazeliğine kavuşturuyoruz.',
    tag: 'Hızlı Hizmet',
    tagColor: 'bg-sky-100 text-sky-700',
    image: 'https://readdy.ai/api/search-image?query=professional%20upholstery%20sofa%20cleaning%20service%20with%20steam%20cleaner%2C%20clean%20white%20sofa%20being%20cleaned%20with%20professional%20equipment%2C%20spotless%20result%2C%20bright%20studio%20lighting&width=600&height=400&seq=service-sofa-1&orientation=landscape',
    whatsapp: 'Koltuk Yıkama',
  },
  {
    icon: 'ri-car-line',
    title: 'Araç Temizliği',
    description: 'İç döşeme, koltuk ve halı temizliği ile aracınızı hijyenik ve pırıl pırıl hale getiriyoruz.',
    tag: 'Hızlı Hizmet',
    tagColor: 'bg-sky-100 text-sky-700',
    image: 'https://readdy.ai/api/search-image?query=professional%20car%20interior%20cleaning%20service%2C%20steam%20cleaning%20car%20seats%20and%20carpet%2C%20detailing%20service%2C%20clean%20and%20bright%20car%20interior%2C%20professional%20equipment&width=600&height=400&seq=service-car-1&orientation=landscape',
    whatsapp: 'Araç Temizliği',
  },
  {
    icon: 'ri-fire-line',
    title: 'Petek Temizliği',
    description: 'Radyatör ve petek temizliğiyle ısıtma veriminizi artırın, enerji tasarrufu yapın.',
    tag: 'Hızlı Hizmet',
    tagColor: 'bg-sky-100 text-sky-700',
    image: 'https://readdy.ai/api/search-image?query=professional%20radiator%20heating%20system%20cleaning%20service%2C%20technician%20cleaning%20radiator%20with%20professional%20tools%2C%20bright%20clean%20home%20interior%20background&width=600&height=400&seq=service-radiator-1&orientation=landscape',
    whatsapp: 'Petek Temizliği',
  },
  {
    icon: 'ri-hotel-bed-line',
    title: 'Yatak Yıkama',
    description: 'Derin temizleme ve buhar yöntemiyle yatak hijyeninizi en üst düzeye çıkarıyoruz.',
    tag: 'Hızlı Hizmet',
    tagColor: 'bg-sky-100 text-sky-700',
    image: 'https://readdy.ai/api/search-image?query=professional%20mattress%20deep%20cleaning%20service%20with%20steam%20extractor%20machine%2C%20clean%20white%20mattress%2C%20hygiene%20cleaning%2C%20professional%20worker%2C%20bright%20background&width=600&height=400&seq=service-mattress-1&orientation=landscape',
    whatsapp: 'Yatak Yıkama',
  },
  {
    icon: 'ri-armchair-line',
    title: 'Sandalye Yıkama',
    description: 'Yemek odası ve ofis sandalyelerinizi profesyonel ekipman ile temizliyor, hijyen sağlıyoruz.',
    tag: 'Hızlı Hizmet',
    tagColor: 'bg-sky-100 text-sky-700',
    image: 'https://readdy.ai/api/search-image?query=professional%20chair%20cleaning%20service%20with%20upholstery%20cleaner%2C%20dining%20chairs%20being%20steam%20cleaned%2C%20clean%20white%20background%2C%20professional%20cleaning%20service&width=600&height=400&seq=service-chair-1&orientation=landscape',
    whatsapp: 'Sandalye Yıkama',
  },
  {
    icon: 'ri-building-2-line',
    title: 'İnşaat Sonrası Temizlik',
    description: 'Renovasyon ve inşaat sonrası kir, toz ve artıkları profesyonel ekipmanla tamamen temizliyoruz.',
    tag: 'Proje Bazlı',
    tagColor: 'bg-amber-100 text-amber-700',
    image: 'https://readdy.ai/api/search-image?query=post%20construction%20cleaning%20service%20team%2C%20workers%20in%20uniform%20cleaning%20newly%20built%20apartment%2C%20removing%20dust%20and%20debris%2C%20professional%20cleaning%20after%20renovation&width=600&height=400&seq=service-construction-1&orientation=landscape',
    whatsapp: 'İnşaat Sonrası Temizlik',
  },
  {
    icon: 'ri-window-line',
    title: 'Dış Cephe Cam Temizliği',
    description: 'Yüksek binalarda güvenli ekipmanlar ile profesyonel dış cephe ve cam temizliği yapıyoruz.',
    tag: 'Proje Bazlı',
    tagColor: 'bg-amber-100 text-amber-700',
    image: 'https://readdy.ai/api/search-image?query=professional%20exterior%20glass%20window%20cleaning%20on%20high%20rise%20building%2C%20rope%20access%20window%20cleaners%2C%20safety%20equipment%2C%20crystal%20clear%20windows%20on%20skyscraper&width=600&height=400&seq=service-window-1&orientation=landscape',
    whatsapp: 'Dış Cephe Cam Temizliği',
  },
  {
    icon: 'ri-home-smile-line',
    title: 'Otel Yatak Yıkama',
    description: 'Otel ve konaklama tesisleri için toplu yatak ve döşeme hijyeni hizmeti veriyoruz.',
    tag: 'Kurumsal',
    tagColor: 'bg-violet-100 text-violet-700',
    image: 'https://readdy.ai/api/search-image?query=hotel%20mattress%20professional%20cleaning%20service%2C%20industrial%20cleaning%20equipment%20in%20hotel%20room%2C%20large%20scale%20hospitality%20cleaning%2C%20professional%20team%2C%20luxury%20hotel%20background&width=600&height=400&seq=service-hotel-1&orientation=landscape',
    whatsapp: 'Otel Yatak Yıkama',
    featured: true,
  },
  {
    icon: 'ri-layout-grid-line',
    title: 'Yerinde Halı / Halıfleks Yıkama',
    description: 'Halılarınızı yerinden çıkarmadan; özel makine ve kimyasallarla yerinde yıkama yapıyoruz.',
    tag: 'Proje Bazlı',
    tagColor: 'bg-amber-100 text-amber-700',
    image: 'https://readdy.ai/api/search-image?query=professional%20carpet%20cleaning%20service%20with%20extraction%20machine%20on%20site%2C%20carpet%20being%20deep%20cleaned%20in%20apartment%2C%20professional%20equipment%2C%20clean%20result%20visible&width=600&height=400&seq=service-carpet-1&orientation=landscape',
    whatsapp: 'Halı / Halıfleks Yıkama',
  },
];

export default function ServicesGrid() {
  const getWhatsAppUrl = (serviceName: string) =>
    `https://wa.me/905055600419?text=Merhaba%2C%20${encodeURIComponent(serviceName)}%20i%C3%A7in%20bilgi%20%2F%20randevu%20almak%20istiyorum.`;

  return (
    <section id="hizmetler" className="py-20 md:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-sky-100 text-sky-700 text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
            Tüm Hizmetlerimiz
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-4">
            Profesyonel Temizlik Çözümleri
          </h2>
          <p className="text-slate-500 text-lg max-w-2xl mx-auto">
            Ev temizliğinden kurumsal projelere kadar geniş hizmet yelpazemizle yanınızdayız.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((service) => (
            <div
              key={service.title}
              className={`group bg-white rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-xl ${service.featured ? 'ring-2 ring-sky-500' : 'shadow-md'}`}
            >
              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {service.featured && (
                  <div className="absolute top-3 right-3 bg-sky-600 text-white text-xs font-bold px-3 py-1 rounded-full">
                    Popüler
                  </div>
                )}
                <div className="absolute top-3 left-3">
                  <span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${service.tagColor}`}>
                    {service.tag}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-sky-100 rounded-xl">
                    <i className={`${service.icon} text-sky-600 text-lg`} />
                  </div>
                  <h3 className="text-lg font-bold text-slate-900">{service.title}</h3>
                </div>
                <p className="text-slate-500 text-sm leading-relaxed mb-4">{service.description}</p>
                <a
                  href={getWhatsAppUrl(service.whatsapp)}
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="inline-flex items-center gap-2 bg-sky-600 hover:bg-sky-700 text-white text-sm font-semibold px-4 py-2.5 rounded-full transition-all w-full justify-center whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line" />
                  WhatsApp&apos;tan Bilgi Al
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
